import React from 'react';

import Link from '../Link';

export const copy = (
  <p>
    Volg vanaf nu met je BNNVARA-account jouw favoriete BNNVARA-titel! Dan
    kunnen we je meer geven wat je echt interesseert. Meer weten?{' '}
    <Link
      disableNextLink
      href="/wijzijnvoor-jijook"
      category="header"
      action="click"
      label="wijzijnvoor-jijook"
    >
      Lees dan hier verder.
    </Link>
  </p>
);

export default copy;
